import { render, staticRenderFns } from "./AdminUpdateContact_old.vue?vue&type=template&id=47e57d67&scoped=true&"
import script from "./AdminUpdateContact_old.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateContact_old.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateContact_old.vue?vue&type=style&index=0&id=47e57d67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e57d67",
  null
  
)

export default component.exports